import { UUID } from '@/types/common';

export const ENDPOINT = {
  ACCOUNT_SETTINGS: {
    GET_ME: () => '/me',
    POST_DISMISSED_BANNERS: () => '/me/dismissed-banners',
    GET_DIRECT_REPORTS: () => '/me/direct-reports',
  },
  OVERVIEW: {
    GET_ALL: () => '/overview',
  },
  ORGANIZATION: {
    GET: () => '/organization',
    GET_BY_ID: () => '/organization/id',
    CREATE: () => '/organization',
    UPDATE: () => '/organization',
  },
  QUESTIONS: {
    GET_ALL: () => '/questions',
    GET: (questionId: UUID) => `/questions/${questionId}`,
  },
  LEADERS: {
    GET_ALL: () => '/leaders',
    GET: (leaderId: UUID) => `/leaders/${leaderId}`,
  },
  SETUP: {
    GET_DOMAIN: () => '/setup/domain',
    GET_SSO: () => '/setup/sso',
    GET_HRIS: () => '/setup/hris',
    GET_SLACK: () => '/setup/slack',
  },
  MANAGEMENT: {
    CATEGORIES: {
      GET_ALL: () => '/management/categories',
      CREATE: () => '/management/categories',
      UPDATE: (categoryId: UUID) => `/management/categories/${categoryId}`,
      DELETE: (categoryId: UUID) => `/management/categories/${categoryId}`,
      TRANSLATE_CATEGORY: () => '/management/categories/translate',
      GET_TRANSLATION_CATEGORY: (categoryId: UUID) =>
        `/management/categories/${categoryId}/translations`,
    },
    QUESTIONS: {
      GET_QUESTIONS: (categoryId: UUID) => `/management/categories/${categoryId}/questions`,
      GET_TRANSLATION: (questionId: UUID) => `/management/questions/${questionId}/translations`,
      CREATE: (categoryId: UUID) => `/management/categories/${categoryId}/questions`,
      UPDATE: (questionId: UUID) => `/management/questions/${questionId}`,
      DELETE: (questionId: UUID) => `/management/questions/${questionId}`,
      TRANSLATE: () => '/management/questions/translate',
      GET_ALL: () => '/management/questions/search',
    },
    SCHEDULE: {
      GET_ALL: () => '/management/schedule',
      CHANGE_QUESTION: (date: string) => `/management/schedule/${date}`,
    },
  },
  METADATA: {
    GET_LEADERS: () => '/metadata/leaders',
    GET_CATEGORIES: () => '/metadata/categories',
    GET_DEPARTMENTS: () => '/metadata/departments',
    GET_SCOPES: () => '/metadata/scopes',
    GET_HRIS_INTEGRATIONS: () => '/metadata/hris-integrations',
  },
  HELPER: {
    VERIFY_DOMAIN: () => '/helper/domain',
    CONFIGURE_SSO: () => '/helper/sso',
    MOCK_DATA: () => '/helper/response-data',
  },
  USERS: {
    GET_ALL: () => '/users',
    UPDATE_ROLE: (userId: UUID) => `/users/${userId}/role`,
  },
  BILLING: {
    GET_STATUS: () => '/billing/status',
    GET_PORTAL: () => '/billing/portal',
    GET_SETUP: () => '/billing/setup',
    SUBSCRIBE: () => '/billing/subscribe',
  },
} as const;
